import React from 'react';

const ConfirmAction = (props) => {
  const {
    onAccept,
    onReject,
    disabled = false,
    appendAccept
  } = props;

  const AppendAccept = appendAccept;

  return (
    <div className="action-confirmation">
      <div className="action-confirmation__bg"></div>
      <div className="action-confirmation__body">
        <div className="action-confirmation__description">{props.children || props.description}</div>
        <div className="action-confirmation__actions">
          <button className="btn btn-form" onClick={onReject}>{props.textReject || i18n.t('confirm_action.reject')}</button>
          <div className="btn-group">
            <button className="btn btn-primary" onClick={onAccept} disabled={disabled}>{props.textAccept || i18n.t('confirm_action.accept')}</button>
            {appendAccept && <AppendAccept />}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmAction;
